import { sortSubscriptionPlansByPriority } from "../modules/LicensesSection/utils/LicenseSection.utils";
import { SUBSCRIPTIONS_API_KEYS } from "../constants/MySubscriptions.constants";

export const dedupeTenurePlans = (plans = []) => {
  if (!Array.isArray(plans)) return [];

  const byRecurrence = new Map();

  plans.filter(Boolean).forEach((plan) => {
    const recurrenceMonths = plan[SUBSCRIPTIONS_API_KEYS.recurrence_months];
    const existing = byRecurrence.get(recurrenceMonths);

    if (
      !existing ||
      (plan[SUBSCRIPTIONS_API_KEYS.is_popular] &&
        !existing[SUBSCRIPTIONS_API_KEYS.is_popular])
    ) {
      byRecurrence.set(recurrenceMonths, plan);
    }
  });

  return Array.from(byRecurrence.values());
};

const normalizePlan = (plan = {}) => ({
  ...plan,
  [SUBSCRIPTIONS_API_KEYS.plans]: dedupeTenurePlans(
    plan[SUBSCRIPTIONS_API_KEYS.plans]
  ),
});

export const normalizeSubscriptionPlansResponse = (data) => {
  if (!data) {
    return {
      [SUBSCRIPTIONS_API_KEYS.subscription_plans]: [],
      total_pages: 0,
      total: 0,
    };
  }

  const rawPlans = data[SUBSCRIPTIONS_API_KEYS.subscription_plans];
  const subscriptionPlans = Array.isArray(rawPlans)
    ? sortSubscriptionPlansByPriority(
        rawPlans.filter(Boolean).map(normalizePlan)
      )
    : [];

  return {
    ...data,
    [SUBSCRIPTIONS_API_KEYS.subscription_plans]: subscriptionPlans,
    total_pages: data.total_pages ?? 0,
    total: data.total ?? subscriptionPlans.length,
  };
};
